import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { all_routes } from '../../../router/all_routes'
import CollapseHeader from '../../../../core/common/collapse-header'
import { checkPermission } from '../../../../core/permissons/CheckPermissons'

const route = all_routes

interface GateManagementLayoutProps {
  children: React.ReactNode
  activeTab: 'relays' | 'cameras' | 'gates'
}

const GateManagementLayout: React.FC<GateManagementLayoutProps> = ({ children, activeTab }) => {
  const navItems = [
    {
      label: 'Relay Devices',
      icon: 'ti ti-device-hub',
      link: route.RelayDevices,
      permission: 'ROLE_VIEW_RELAY_DEVICE',
      key: 'relays',
    },
    {
      label: 'Cameras',
      icon: 'ti ti-camera',
      link: route.Cameras,
      permission: 'ROLE_VIEW_CAMERA',
      key: 'cameras',
    },
    {
      label: 'Gates',
      icon: 'ti ti-door-enter',
      link: route.Gates,
      permission: 'ROLE_VIEW_GATE',
      key: 'gates',
    },
  ]

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="row">
          <div className="col-md-12">
            {/* Page Header */}
            <div className="page-header">
              <div className="row align-items-center">
                <div className="col-8">
                  <h4 className="page-title">Administration / Gate Management</h4>
                </div>
                <div className="col-4 text-end">
                  <div className="head-icons">
                    <CollapseHeader />
                  </div>
                </div>
              </div>
            </div>
            {/* /Page Header */}

            {/* Navigation Tabs */}
            <div className="card">
              <div className="card-body pb-0 pt-2">
                <ul className="nav nav-tabs nav-tabs-bottom" style={{ gap: '12px', display: 'flex' }}>
                  {navItems.map(
                    (item) =>
                      item.permission &&
                      checkPermission(item.permission) && (
                        <li className="nav-item me-item" key={item.key}>
                          <Link
                            to={item.link}
                            className={`nav-link px-0 ${activeTab === item.key ? 'active' : ''}`}
                          >
                            <i className={`${item.icon} me-1`} /> {item.label}
                          </Link>
                        </li>
                      )
                  )}
                </ul>
              </div>
            </div>
            {/* /Navigation Tabs */}

            {/* Main Content */}
            {children}
          </div>
        </div>
      </div>
    </div>
  )
}

export default GateManagementLayout
